import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { Order } from '../../../models';
import { OrderInfo } from './order/OrderInfo';

export const PreviousOrderHistory = (
  { previousOrders }: { previousOrders: Order[] },
) => {
  const renderOrderDetails = () => previousOrders.map(order => (
    <OrderInfo
      key={`previous-order-${order.id}`}
      order={order}
    />
  ));

  return (
    <Box
      id="previous-order-container"
      display="flex"
      flexDirection="column"
      paddingBottom={2}
    >
      <Box id="pending-order-title">
        <Typography paddingY={2} fontSize={24} fontWeight={600} color="#43509B" lineHeight="135%">
          <FormattedMessage id="page.order.history.previous.order.title" />
        </Typography>
      </Box>
      {renderOrderDetails()}
    </Box>
  );
};
